import {
  HTTP_DELETEPROJECT_FETCHING,
  HTTP_DELETEPROJECT_SUCCESS,
  HTTP_DELETEPROJECT_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DELETEPROJECT_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_DELETEPROJECT_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_DELETEPROJECT_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
